import styles from './Badge.module.css';

export function Badge({ children, tone = 'neutral', size = 'md', className = '' }) {
  return (
    <span className={`${styles.badge} ${styles[tone]} ${styles[size]} ${className}`}>
      {children}
    </span>
  );
}

/**
 * Plan badge.
 *
 * "Unlimited" is a user-facing promise, so Premium is presented plainly and
 * Free is never framed as a deficiency.
 */
export function PlanBadge({ plan, status, className = '' }) {
  if (plan === 'pro') {
    const label =
      status === 'trialing'
        ? 'Premium trial'
        : status === 'canceled_active'
          ? 'Premium (ending)'
          : status === 'grace_period' || status === 'billing_issue'
            ? 'Premium (billing issue)'
            : 'Premium';

    return (
      <Badge tone="premium" className={className}>
        {label}
      </Badge>
    );
  }

  return (
    <Badge tone="neutral" className={className}>
      Free
    </Badge>
  );
}
